module.exports = __webpack_public_path__ + "img/text2.35431e37.png";